import { render, staticRenderFns } from "./menupopup.vue?vue&type=template&id=5ad2291e&scoped=true&"
import script from "./menupopup.vue?vue&type=script&lang=js&"
export * from "./menupopup.vue?vue&type=script&lang=js&"
import style0 from "./menupopup.vue?vue&type=style&index=0&id=5ad2291e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad2291e",
  null
  
)

export default component.exports